"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const js_sdk_common_1 = require("@launchdarkly/js-sdk-common");
const Reasons_1 = require("./Reasons");
const { createErrorEvaluationDetail, createSuccessEvaluationDetail } = js_sdk_common_1.internal;
/**
 * A class which encapsulates the result of an evaluation. It allows for differentiating between
 * successful and error result types.
 *
 * @internal
 */
class EvalResult {
    constructor(isError, detail, message) {
        this.isError = isError;
        this.detail = detail;
        this.message = message;
        this.isError = isError;
        this.detail = detail;
        this.message = message;
    }
    get isOff() {
        return this.detail.reason.kind === Reasons_1.default.Off.kind;
    }
    setDefault(def) {
        this.detail.value = def;
    }
    static forError(errorKind, message, def) {
        return new EvalResult(true, createErrorEvaluationDetail(errorKind, def), message);
    }
    static forSuccess(value, reason, variationIndex) {
        const successDetail = createSuccessEvaluationDetail(value, variationIndex, reason);
        return new EvalResult(false, successDetail);
    }
}
exports.default = EvalResult;
//# sourceMappingURL=EvalResult.js.map